import React from "react";
import "./Collaborative_Culture.css";
import Apply_Modal from "../../Common_Component/Apply_Modal/Apply_Modal";

function Collaborative_Culture() {
  const [modalShow, setModalShow] = React.useState(false);
  return (
    <>
      <section className="Collaborative_Culture">
        <div className="container">
          <div className="heading-holder">
            <h3>
              <span>Collaborative</span> Culture
            </h3>
          </div>
          <div className="main-content-holder">
            <div className="main-text-holder">
              <p>
                Our team is our greatest asset. We value teamwork, open
                communication, & collaboration, ensuring that every voice is
                heard and every contribution is recognized.
              </p>
            </div>

            <div className="opening_heading_holder">
              <div className="opening-heading">
                <h3>Current Openings</h3>
              </div>
            </div>

            <div className="opening-holder">
              <div className="opening-list">
                <div className="row">
                  <div className="col-md-9">
                    <div className="text-holder">
                      <h3>Digital Marketing Executive</h3>
                      <p>
                        As a Digital Marketing Executive, you'll develop and
                        implement strategies to drive traffic, boost engagement,
                        and increase brand visibility. Managing social media,
                        optimizing SEO, and analyzing performance metrics will
                        be key aspects of your role, working closely with the
                        creative team to deliver impactful campaigns.
                      </p>
                    </div>
                  </div>

                  <div className="col-md-3">
                    <div className="apply-btn-holder">
                      <p>Apply</p>
                      <div
                        className="apply-btn"
                        onClick={() => setModalShow(true)}
                      >
                        <img
                          className="arrow_up_right_img"
                          src={
                            process.env.PUBLIC_URL +
                            "/Assets/Images/Career/Collaborative_Culture/arrow_up_right.png"
                          }
                        />
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <div className="opening-list">
                <div className="row">
                  <div className="col-md-9">
                    <div className="text-holder">
                      <h3>Graphic Designer</h3>
                      <p>
                        We are looking for a talented Graphic Designer to create
                        eye-catching designs for digital and print media,
                        including ads, social media, and websites. If you have
                        strong design skills, experience with Adobe Creative
                        Suite, and a passion for branding, join our creative
                        team!
                      </p>
                    </div>
                  </div>

                  <div className="col-md-3">

                  <div className="apply-btn-holder">
                      <p className="applied_success_text">Applied</p>
                   
                    </div>
                
                  </div>
                </div>
              </div>

              <div className="opening-list">
                <div className="row">
                  <div className="col-md-9">
                    <div className="text-holder">
                      <h3>Sales and Marketing Manager</h3>
                      <p>
                        As a Sales and Marketing Manager at ReachOut Media Tech
                        Pvt. Ltd., you’ll lead sales operations, develop
                        marketing strategies, and build strong client
                        relationships. Your focus will be on driving growth,
                        identifying new opportunities, and delivering results
                        that support our vision in digital advertising.
                      </p>
                    </div>
                  </div>

                  <div className="col-md-3">
                    <div className="apply-btn-holder">
                      <p>Apply</p>
                      <div
                        className="apply-btn"
                        onClick={() => setModalShow(true)}
                      >
                        <img
                          className="arrow_up_right_img"
                          src={
                            process.env.PUBLIC_URL +
                            "/Assets/Images/Career/Collaborative_Culture/arrow_up_right.png"
                          }
                        />
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

       
      </section>
      <Apply_Modal show={modalShow} onHide={() => setModalShow(false)} />
    </>
  );
}

export default Collaborative_Culture;
